<div class="view-wrapper" @viewLoader>
  <div
    class="view-content xl overview"
    [class.has-right-column]="dashboard.showProfileCompleteness()"
  >
    <div class="left">
      @if (dashboard.isDashboardEmpty()) {
        <div class="ct-card dashboard-empty">
          <ct-lib-empty-placeholder
            [icon]="icons.user"
            [title]="'jobboard.platform.dashboard.empty-title' | transloco"
            [text]="'jobboard.platform.dashboard.empty-text' | transloco"
          >
            <div emptyPlaceholderActions class="empty-cta-actions">
              <app-button
                variant="primary"
                [iconStart]="icons.user"
                [routerLink]="['/profile']"
              >
                {{ 'jobboard.platform.dashboard.empty-cta-profile' | transloco }}
              </app-button>
              <app-button
                variant="white-grey"
                [iconStart]="icons.search"
                [routerLink]="
                  dashboard.hasJobRecommendations()
                    ? ['/jobs']
                    : ['/']
                "
              >
                {{ 'jobboard.platform.dashboard.empty-cta-jobs' | transloco }}
              </app-button>
            </div>
          </ct-lib-empty-placeholder>
        </div>
      } @else {
        <app-platform-dashboard-tasks
          (openChoice)="openFollowUpChoice($event)"
        ></app-platform-dashboard-tasks>
        <app-platform-dashboard-invitations></app-platform-dashboard-invitations>
        <app-platform-dashboard-applications></app-platform-dashboard-applications>
      }
      <div class="bottom-space"></div>
    </div>

    @if (dashboard.showProfileCompleteness()) {
      <div class="right">
        <app-platform-dashboard-profile-completeness></app-platform-dashboard-profile-completeness>
      </div>
    }
  </div>
</div>

<app-platform-follow-up-choice-modal
  #choiceModal
  (chooseManual)="openCompleteModal($event.id)"
/>

<app-platform-jobs-complete-modal
  #completeModal
  [application]="completingApplication()"
  (completed)="onCompleted()"
/>
